import script from "./TeresaStandardCode.vue?vue&type=script&setup=true&lang=js"
export * from "./TeresaStandardCode.vue?vue&type=script&setup=true&lang=js"

import "./TeresaStandardCode.vue?vue&type=style&index=0&id=55497637&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55497637"]])

export default __exports__